export const TOGGLE_EDIT_BATCH_SELECTION = "TOGGLE_EDIT_BATCH_SELECTION";
export const TOGGLE_FETCH_REGULATION_PANEL = "TOGGLE_FETCH_REGULATION_PANEL";
export const FETCH_MATCHING_BATCH_REGULATIONS = "FETCH_MATCHING_BATCH_REGULATIONS";
export const MATCHING_BATCH_REGULATIONS_RECEIVED = "MATCHING_BATCH_REGULATIONS_RECEIVED";
export const TOGGLE_FETCH_REGULATION_SELECTION = "TOGGLE_FETCH_REGULATION_SELECTION";
export interface ToggleEditBatchSelectionAction {
    type: typeof TOGGLE_EDIT_BATCH_SELECTION;
    payload: { isEditBatchSelectionEnabled: boolean };
}

export interface ToggleFetchRegulationSelectionAction {
    type: typeof TOGGLE_FETCH_REGULATION_SELECTION;
    payload: { isFetchRegulationSelection: boolean };
}
export interface ToggleFetchRegulationPanelAction {
    type: typeof TOGGLE_FETCH_REGULATION_PANEL;
    payload: { isFetchRegulationPanelOpen: boolean };
}

export interface EditBatchSelectionState {
    isEditBatchSelectionEnabled: boolean;
    isFetchRegulationPanelOpen: boolean;
    matchingBatchRegulations: MatchingBatchRegulationsReceived["payload"];
    isFetchRegulationSelection: boolean;
}

export interface FetchMatchingBatchRegulationsAction {
    type: typeof FETCH_MATCHING_BATCH_REGULATIONS;
    payload: {
        afterProcess?: () => void;
        params: {
            date: string;
            linkIds: number[];
            current_time: string;
            regulations: {
                sub_activity_id: number;
                from_time: string;
                to_time: string;
            }[];
        };
    };
}

export interface MatchingBatchRegulationsReceived {
    type: typeof MATCHING_BATCH_REGULATIONS_RECEIVED;
    payload: {
        link_ids: number[];
        sub_activity_id: number;
        from_time: string;
        to_time: string;
    }[];
}

export type EditBatchSelectionTypes =
    | ToggleEditBatchSelectionAction
    | ToggleFetchRegulationPanelAction
    | FetchMatchingBatchRegulationsAction;
